import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import _ from 'underscore';
import { Page, Header } from 'components';
import { TopOffendersWorstCitiesForm } from './components';
import { SetFormState } from '../actions/WorstSitesCitiesActions';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	sitelist: {
		marginTop: theme.spacing(6)
	}
}));

const WorstSitesCitiesExport = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.TopOffendersWorstSitesCitiesReducers.formState);

	useEffect(() => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				city: '',
				startDate: null,
				endDate: null,
				topSites: '10',
			},
			touched: {
				...formState.touched,
				site: false
			}
		});
	}, []);

	return (
		<Page className={classes.root} title="Top Offenders">
			<Header module="Top Offenders" view="Cities Worst Sites (Impacted and Sorted)" />
			<TopOffendersWorstCitiesForm />
		</Page>
	);
};

export default WorstSitesCitiesExport;
